var _line, _line2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 44,
    viewBox: "0 0 336 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 15.5,
    x2: 143,
    y2: 15.5,
    stroke: "#FEFEFE"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 193,
    y1: 15.5,
    x2: 336,
    y2: 15.5,
    stroke: "#FEFEFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 10,
    width: 20,
    height: 14,
    rx: 2,
    ry: 2,
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 10,
    x2: 180,
    y2: 24,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 10,
    x2: 160,
    y2: 24,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162,
    y1: 13,
    x2: 178,
    y2: 13,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162,
    y1: 17,
    x2: 178,
    y2: 17,
    stroke: "#000",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparator);
export default __webpack_public_path__ + "static/media/separator.9d5e6264fc982a8389b69b52237919f0.svg";
export { ForwardRef as ReactComponent };